



















































import { Component, Prop, Mixins } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";
import UtilMixin from "@/mixins/utilMixin";
import SearchBase from "@/components/admin_common/SearchBase.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import { PortalJobsearchListing } from "@/model/portal";

@Component({
  components: {
    AppTextField,
    SearchBase,
    AppAuthButton,
  },
})
export default class extends Mixins(AxiosMixin, UtilMixin) {
  private searchKey = ""; //絞り込み文字列

  /** 求人情報 */
  @Prop({
    type: Array,
    default: () => [],
  })
  readonly items!: PortalJobsearchListing[];

  private headers = [
    { text: "詳細", value: "action" },
    { text: "組織名", value: "portal_office_name" },
    { text: "HST番号", value: "hst_no", width: "150px" },
    { text: "事業所コード", value: "kst_no", width: "150px" },
    { text: "求人ID", value: "id", width: "100px" },
    { text: "求人タイトル", value: "listing_title" },
  ];

  /** 詳細ボタンクリック時 */
  private goDetail(id: number) {
    /** 詳細画面へ遷移 */
    this.$router.push({
      path: `/jobsearch/jobsearch-listing/detail/${id}`,
    });
  }
}
